/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
import { Table, Space, Button, Select, Switch } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

import EditDiscordMentorModal from "./EditMentorModal";
import { showErrorNotification, showSuccessNotification } from "../../../../utils/notification";
import { clamp } from "../../../../utils/responsiveHelpers";

const DiscordAnalyticsMentorsListDashboard = ({ ROOT_URL }) => {
  const [mentorsList, setMentorsList] = useState([]);
  const [websiteBatchesList, setWebsiteBatchesList] = useState([]);
  const [currentMentorEditId, setCurrentMentorEditId] = useState("");
  const [initialValues, setInitialValues] = useState({});
  const [showMentorEditModal, setShowMentorEditModal] = useState(false);
  const [filter, setFilter] = useState({
    batchId: null,
    is_on_platform: true
  });

  const fetchMentorsList = () => {
    axios
      .get(`${ROOT_URL}/admin/discord-analytics/mentors/management/list`, {
        params: {
          filter
        }
      })
      .then((res) => {
        const { mentorsIndexedList = [] } = res.data;
        setMentorsList(mentorsIndexedList);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchWebsiteBatchesList = () => {
    axios
      .get(`${ROOT_URL}/admin/discord-analytics/mentors/management/batches-list`, {})
      .then((res) => {
        const { batchesList = [] } = res.data;
        setWebsiteBatchesList(batchesList);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleUpdateMentor = (formInput) => {
    axios
      .post(`${ROOT_URL}/admin/discord-analytics/mentors/management/update`, {
        mentorDiscordId: currentMentorEditId,
        mentorParams: formInput
      })
      .then(() => {
        fetchMentorsList();
        setShowMentorEditModal(false);
        showSuccessNotification("Mentor Updated Successfully.");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const mentorsTableColumn = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Discord Id",
      dataIndex: "discordId",
      key: "discordId"
    },

    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => {
        if (typeof a.name === "string" && typeof b.name === "string") {
          return a.name?.localeCompare(b.name) | 0;
        }
        // Fallback comparison if not string (handle the case if one or both values are not strings)
        return 0;
      }
    },
    {
      title: "Discord Alias",
      dataIndex: "discordUserName",
      key: "discordUserName"
    },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   key: "email"
    // },
    {
      title: "Mobile Number",
      dataIndex: "mobileNumber",
      key: "mobileNumber"
    },
    {
      title: "Batches",
      dataIndex: "batchNames",
      key: "batchNames"
    },
    {
      title: "Actions",
      key: "action",
      render: (row) => (
        <div
          id="users_row_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around"
          }}
        >
          <Space wrap>
            <>
              <Button
                type="primary"
                onClick={() => {
                  setCurrentMentorEditId(row.discordId);
                  setInitialValues(row);
                  setShowMentorEditModal(true);
                }}
              >
                Edit
              </Button>
            </>
          </Space>
        </div>
      )
    }
  ];

  useEffect(() => {
    fetchMentorsList();
  }, [filter]);

  useEffect(() => {
    fetchWebsiteBatchesList();
  }, []);

  return (
    <div
      style={{
        marginTop: "20px",
        marginLeft: clamp(12, 30),
        marginRight: clamp(12, 30)
      }}
    >
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
        <span>Batch:</span>
        <Select
          showSearch
          placeholder="Select Batch"
          style={{ width: "min(200px, 100%)", marginBottom: 10 }}
          optionFilterProp="children"
          onChange={(value) => {
            setFilter((prevFilter) => ({
              ...prevFilter,
              batchId: value
            }));
          }}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {(websiteBatchesList || []).map((batch) => (
            <Select.Option value={batch.value} key={batch.value}>
              {batch.label}
            </Select.Option>
          ))}
        </Select>

        <div>
          <Switch
            checked={filter.is_on_platform}
            onChange={(checked) =>
              setFilter((prev) => ({
                ...prev,
                is_on_platform: checked
              }))
            }
          />{" "}
          Show Only Active Mentors
        </div>
      </div>
      <div
        style={{
          marginBottom: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "5px"
        }}
      >
        <h3>Mentors</h3>
        <Table
          columns={mentorsTableColumn}
          dataSource={mentorsList}
          bordered
          scroll={{ x: "max-content" }}
        />
      </div>
      {showMentorEditModal === true && (
        <EditDiscordMentorModal
          isModalOpen={showMentorEditModal}
          websiteBatchesList={websiteBatchesList}
          setIsModalOpen={setShowMentorEditModal}
          initialValues={initialValues}
          handleEditMentorModal={handleUpdateMentor}
        />
      )}
    </div>
  );
};

export default DiscordAnalyticsMentorsListDashboard;
